
(function () {
  'use strict';

  function navLinkMatchesSection(href, sectionId) {
    if (!href || !sectionId) return false;
    var hash = '#' + sectionId;
    if (href === hash || href.endsWith(hash)) return true;
    try {
      return new URL(href, window.location.origin).hash === hash;
    } catch (e) {
      return false;
    }
  }

  function init() {
    var root = document.querySelector('[data-pixelmob-root]');
    var navHost = document.querySelector('[data-pixelmob-nav]');
    if (!root && !navHost) return;

    if (navHost && navHost.dataset.pixelmobNavInit !== '1') {
      navHost.dataset.pixelmobNavInit = '1';
      initMobileMenu(navHost);
      initNavLanguageHover(navHost);
      initNavLanguageSelect(navHost);
    }

    if (!root || root.dataset.pixelmobInit === '1') return;
    root.dataset.pixelmobInit = '1';

    if (root && navHost) initNavHighlight(root, navHost);
    initHeroForm(root);
    initSecurityFortress(root);
    initCapabilityTabs(root);
    initCapabilityProgress(root);
    initTimeline(root);
    initTimelineMobileProgress(root);
    initTilt(root);
    initScrollReveal(root);
    initEmailInputSnapFix(root);
  }

  function initEmailInputSnapFix(root) {
    var html = document.documentElement;
    var focusCount = 0;
    root.querySelectorAll('input[type="email"]').forEach(function (input) {
      input.addEventListener('focus', function () {
        focusCount += 1;
        html.classList.add('pixelmob-email-focus');
      });
      input.addEventListener('blur', function () {
        focusCount = Math.max(0, focusCount - 1);
        if (focusCount === 0) html.classList.remove('pixelmob-email-focus');
      });
    });
  }

  function isLocalThemeDev() {
    return /^(127\.0\.0\.1|localhost)$/i.test(window.location.hostname);
  }

  function buildLocalizationReturnTo() {
    var path = window.location.pathname || '/';
    var search = window.location.search || '';
    if (isLocalThemeDev() && window.Shopify && window.Shopify.theme && window.Shopify.theme.id) {
      if (search.indexOf('preview_theme_id=') === -1) {
        search += (search ? '&' : '?') + 'preview_theme_id=' + window.Shopify.theme.id;
      }
    }
    return path + search;
  }

  function submitLocalizationToShop(navRoot, locale) {
    var shopUrl = navRoot && navRoot.getAttribute('data-shop-url');
    if (!shopUrl || !isLocalThemeDev()) return false;

    var shop;
    try {
      shop = new URL(shopUrl);
    } catch (err) {
      return false;
    }

    var country =
      (navRoot.getAttribute('data-country-code') || '').trim() ||
      (navRoot.querySelector('[data-pixelmob-country-input]') || {}).value ||
      '';

    var form = document.createElement('form');
    form.method = 'post';
    form.action = shop.origin + '/localization';
    form.style.display = 'none';

    var fields = {
      form_type: 'localization',
      utf8: '\u2713',
      _method: 'put',
      locale_code: locale,
      language_code: locale,
      country_code: country,
      return_to: buildLocalizationReturnTo()
    };

    Object.keys(fields).forEach(function (name) {
      var field = document.createElement('input');
      field.type = 'hidden';
      field.name = name;
      field.value = fields[name];
      form.appendChild(field);
    });

    document.body.appendChild(form);
    form.submit();
    return true;
  }

  function submitNavLanguageForm(form, locale) {
    var localeInput = form.querySelector('[data-pixelmob-locale-input], input[name="locale_code"]');
    var languageInput = form.querySelector('[data-pixelmob-language-input], input[name="language_code"]');
    var countryInput = form.querySelector('[data-pixelmob-country-input], input[name="country_code"]');
    var returnInput = form.querySelector('[data-pixelmob-return-to], input[name="return_to"]');

    if (localeInput) localeInput.value = locale;
    if (languageInput) languageInput.value = locale;
    if (returnInput) returnInput.value = buildLocalizationReturnTo();

    if (form.requestSubmit) form.requestSubmit();
    else form.submit();
  }

  function initNavLanguageSelect(container) {
    var navRoot = container.closest('[data-pixelmob-nav]') || container;

    container.querySelectorAll('.pixelmob-nav-language-form').forEach(function (lf) {
      var form = lf.querySelector('form');
      if (!form) return;

      lf.querySelectorAll('a.pixelmob-nav-language-option[data-value]').forEach(function (link) {
        link.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();

          var locale = link.getAttribute('data-value');
          if (!locale) return;

          if (submitLocalizationToShop(navRoot, locale)) return;
          submitNavLanguageForm(form, locale);
        });
      });
    });
  }

  function initNavLanguageHover(container) {
    var mq = window.matchMedia('(min-width: 768px)');
    container.querySelectorAll('[data-pixelmob-lang-hover]').forEach(function (wrap) {
      var panel = wrap.querySelector('.pixelmob-nav-language-panel');
      var btn = wrap.querySelector('button');
      if (!panel || !btn) return;

      function openPanel() {
        if (!mq.matches) return;
        panel.removeAttribute('hidden');
        btn.setAttribute('aria-expanded', 'true');
      }

      function closePanel() {
        if (!mq.matches) return;
        panel.setAttribute('hidden', '');
        btn.setAttribute('aria-expanded', 'false');
      }

      var closeTimer;
      function scheduleClose() {
        closeTimer = window.setTimeout(closePanel, 120);
      }
      function cancelClose() {
        window.clearTimeout(closeTimer);
      }

      wrap.addEventListener('mouseenter', function () {
        cancelClose();
        openPanel();
      });
      wrap.addEventListener('mouseleave', scheduleClose);
      panel.addEventListener('mouseenter', cancelClose);
      panel.addEventListener('mouseleave', scheduleClose);
      wrap.addEventListener('focusin', openPanel);
      wrap.addEventListener('focusout', function (e) {
        if (!wrap.contains(e.relatedTarget)) scheduleClose();
      });
    });
  }

  function initMobileMenu(container) {
    var btn = container.querySelector('[data-pixelmob-menu-toggle]');
    var nav = container.querySelector('[data-pixelmob-mobile-nav]');
    var backdrop = container.querySelector('[data-pixelmob-nav-backdrop]');
    if (!btn || !nav) return;

    function setMenuOpen(open) {
      nav.classList.toggle('is-open', open);
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (backdrop) {
        backdrop.classList.toggle('is-visible', open);
        backdrop.setAttribute('aria-hidden', open ? 'false' : 'true');
      }
      if (open) {
        document.addEventListener('keydown', onKeydown);
        document.addEventListener('pointerdown', onPointerDown, true);
      } else {
        document.removeEventListener('keydown', onKeydown);
        document.removeEventListener('pointerdown', onPointerDown, true);
      }
    }

    function onKeydown(e) {
      if (e.key === 'Escape') setMenuOpen(false);
    }

    function onPointerDown(e) {
      if (!nav.classList.contains('is-open')) return;
      if (container.contains(e.target)) return;
      setMenuOpen(false);
    }

    btn.addEventListener('click', function () {
      setMenuOpen(!nav.classList.contains('is-open'));
    });

    if (backdrop) {
      backdrop.addEventListener('click', function () {
        setMenuOpen(false);
      });
    }

    nav.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', function () {
        setMenuOpen(false);
      });
    });
  }

  function initNavHighlight(contentRoot, navRoot) {
    var sections = contentRoot.querySelectorAll('section[id]');
    var navLinks = navRoot.querySelectorAll('[data-pixelmob-nav-link], .pixelmob-nav-link[href*="#"]');
    if (!sections.length || !navLinks.length || !('IntersectionObserver' in window)) return;

    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var id = entry.target.id;
        navLinks.forEach(function (a) {
          var active = navLinkMatchesSection(a.getAttribute('href') || '', id);
          a.classList.toggle('text-orange-500', active);
          a.classList.toggle('is-active', active);
          a.classList.toggle('text-white', !active);
        });
      });
    }, { threshold: 0.3 });

    sections.forEach(function (s) { obs.observe(s); });
  }

  function initHeroForm(root) {
    var group = root.querySelector('[data-hero-form]');
    if (!group) return;

    var input = group.querySelector('input[type="email"]');
    if (!input) return;

    function checkValue() {
      group.classList.toggle('has-value', input.value.length > 0);
    }

    group.addEventListener('mouseenter', function () {
      group.classList.add('is-hovered');
    });
    group.addEventListener('mouseleave', function () {
      group.classList.remove('is-hovered');
    });

    input.addEventListener('input', checkValue);
    input.addEventListener('focus', function () {
      group.classList.add('is-hovered');
    });
    input.addEventListener('blur', function () {
      if (!input.value) group.classList.remove('is-hovered');
    });

    checkValue();
  }

  /* ── Security Fortress ───────────────────────── */
  function initSecurityFortress(root) {
    var fortress = root.querySelector('[data-security-fortress]');
    if (!fortress) return;
    var layers = fortress.querySelectorAll('.pixelmob-security-layer');
    var layerWrap = fortress.querySelector('#pixelmob-security-layers');
    var bottomLabel = fortress.querySelector('.pixelmob-security-bottom');

    // Active styles are now handled purely via CSS data-layer-index selectors

    // ── Entry animation (IntersectionObserver stagger) ──

    if (!('IntersectionObserver' in window)) {
      return;
    }
    layers.forEach(function(layer) { layer.classList.add('is-anim-pending'); });
    if (bottomLabel) bottomLabel.classList.add('is-anim-pending');

    var observed = false;
    var observer = new IntersectionObserver(function(entries) {
      if (observed) return;
      if (!entries[0].isIntersecting) return;
      observed = true;
      layers.forEach(function(layer, i) {
        layer.style.transitionDelay = (i * 100) + 'ms';
      });
      requestAnimationFrame(function() {
        requestAnimationFrame(function() {
          layers.forEach(function(layer) {
            layer.classList.add('is-in-view');
          });
          if (bottomLabel) {
            bottomLabel.style.transitionDelay = '700ms';
            bottomLabel.classList.add('is-in-view');
          }

          setTimeout(function() {
            layers.forEach(function(layer) {
              layer.style.transitionDelay = '';
              layer.classList.remove('is-anim-pending');
            });
            if (bottomLabel) {
              bottomLabel.style.transitionDelay = '';
              bottomLabel.classList.remove('is-anim-pending');
            }
          }, 700 + 300 + 50);
        });
      });
      observer.disconnect();
    }, { threshold: 0.2 });
    observer.observe(fortress);

    setTimeout(function() {
      if (observed) return;
      layers.forEach(function(layer) { layer.classList.remove('is-anim-pending'); });
      if (bottomLabel) bottomLabel.classList.remove('is-anim-pending');
    }, 5000);

    // ── Hover (desktop) / tap (touch) interaction ──
    function prefersHover() {
      return window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    }

    layers.forEach(function(layer) {
      function activate() {
        layers.forEach(function(l) { l.classList.remove('is-active'); });
        layer.classList.add('is-active');
      }

      function deactivate() {
        layer.classList.remove('is-active');
      }

      layer.addEventListener('mouseenter', function() {
        if (prefersHover()) activate();
      });
      layer.addEventListener('mouseleave', function() {
        if (prefersHover()) deactivate();
      });
      layer.addEventListener('click', function() {
        if (prefersHover()) return;
        if (layer.classList.contains('is-active')) deactivate();
        else activate();
      });
      layer.addEventListener('keydown', function(e) {
        if (e.key !== 'Enter' && e.key !== ' ') return;
        e.preventDefault();
        if (layer.classList.contains('is-active')) deactivate();
        else activate();
      });
    });
  }

  /* ── Capability Matrix Tabs ──────────────────── */

  function initCapabilityProgress(root) {
    var panels = root.querySelectorAll('.pixelmob-tab-panel');
    panels.forEach(function (panel) {
      var scroller = panel.querySelector('[data-cap-scroll]');
      var dotsWrap = panel.querySelector('[data-cap-dots]');
      if (!scroller || !dotsWrap) return;
      var dots = dotsWrap.querySelectorAll('.pixelmob-cap-dot-item');
      if (!dots.length) return;

      function update() {
        var cardWidth = scroller.clientWidth * 0.82 + 12; // 82vw + gap-3(12px)
        var idx = Math.round(scroller.scrollLeft / cardWidth);
        idx = Math.max(0, Math.min(idx, dots.length - 1));
        dots.forEach(function (d, i) {
          d.classList.toggle('is-active', i === idx);
        });
      }

      scroller.addEventListener('scroll', update, { passive: true });
      update();
    });
  }

  function syncCapabilityFooter(root, tabId) {
    var footer = root.querySelector('[data-capability-footer]');
    if (!footer) return;
    footer.querySelectorAll('[data-foot-tab]').forEach(function (item) {
      var active = item.getAttribute('data-foot-tab') === tabId;
      item.classList.toggle('is-tab-active', active);
    });
  }

  function initCapabilityTabs(root) {
    var tabWrap = root.querySelector('[data-capability-tabs]');
    if (!tabWrap) return;
    var btns = tabWrap.querySelectorAll('.pixelmob-tab-btn');
    var panels = root.querySelectorAll('.pixelmob-tab-panel');

    btns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var tabId = btn.getAttribute('data-tab');
        btns.forEach(function (b) {
          b.classList.remove('bg-orange-500', 'text-black', 'shadow-[0_0_20px_rgba(249,115,22,0.3)]');
          b.classList.add('bg-zinc-900', 'text-zinc-500', 'border', 'border-zinc-800');
        });
        btn.classList.add('bg-orange-500', 'text-black', 'shadow-[0_0_20px_rgba(249,115,22,0.3)]');
        btn.classList.remove('bg-zinc-900', 'text-zinc-500', 'border', 'border-zinc-800');

        panels.forEach(function (p) {
          p.classList.toggle('is-active', p.getAttribute('data-panel') === tabId);
        });

        syncCapabilityFooter(root, tabId);
      });
    });

    syncCapabilityFooter(root, 'capture');
  }

  /* ── Day Timeline (desktop hover expand) ─────── */
  function initTimeline(root) {
    var wrap = root.querySelector('#pixelmob-timeline');
    if (!wrap) return;
    var cards = wrap.querySelectorAll('.pixelmob-timeline-card');

    var glowAccentMap = {
      'rgba(251,191,36,0.3)':  '#fbbf24',  // amber-400
      'rgba(34,211,238,0.3)':  '#22d3ee',  // cyan-400
      'rgba(251,146,60,0.3)':  '#fb923c',  // orange-400
      'rgba(96,165,250,0.3)':  '#60a5fa',  // blue-400
      'rgba(168,85,247,0.3)':  '#a855f7',  // purple-400
      'rgba(139,92,246,0.3)':  '#8b5cf6',  // violet-400
    };

    function deactivateAll() {
      cards.forEach(function (c) {
        c.classList.remove('is-active');
        c.style.boxShadow = 'none';
        var time = c.querySelector('.pixelmob-tl-time');
        var feat = c.querySelector('.pixelmob-tl-feature');
        var desc = c.querySelector('.pixelmob-timeline-desc');
        if (time) time.style.color = '';
        if (feat) feat.style.color = '';
        if (desc) { desc.style.maxHeight = '0'; desc.style.opacity = '0'; desc.style.marginTop = '0'; }
      });
      wrap.classList.remove('pixelmob-any-active');
    }

    function activate(card) {
      deactivateAll();
      wrap.classList.add('pixelmob-any-active');
      card.classList.add('is-active');
      var glow = card.getAttribute('data-glow') || '';
      var accent = glowAccentMap[glow] || '#ffffff';
      card.style.boxShadow = '0 8px 40px ' + glow;
      var time = card.querySelector('.pixelmob-tl-time');
      var feat = card.querySelector('.pixelmob-tl-feature');
      var desc = card.querySelector('.pixelmob-timeline-desc');
      if (time) time.style.color = accent;
      if (feat) feat.style.color = accent;
      if (desc) { desc.style.maxHeight = '12rem'; desc.style.opacity = '1'; desc.style.marginTop = '12px'; }
    }

    cards.forEach(function (card) {
      card.addEventListener('mouseenter', function () { activate(card); });
      card.addEventListener('click', function () {
        if (card.classList.contains('is-active')) { deactivateAll(); } else { activate(card); }
      });
      card.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') card.click();
      });
    });

    wrap.addEventListener('mouseleave', deactivateAll);
  }

  /* ── Timeline mobile progress dots ──────────── */
  function initTimelineMobileProgress(root) {
    var dotsWrap = root.querySelector('[data-tl-dots]');
    if (!dotsWrap) return;
    var dots = dotsWrap.querySelectorAll('.pixelmob-tl-dot');
    if (!dots.length) return;
    var snapScroller = dotsWrap.previousElementSibling;
    if (!snapScroller) return;

    function update() {
      var total = dots.length;
      // cardWidth = 82vw + gap-3(12px)
      var cardWidth = snapScroller.clientWidth * 0.82 + 12;
      var idx = Math.round(snapScroller.scrollLeft / cardWidth);
      idx = Math.max(0, Math.min(idx, total - 1));
      dots.forEach(function (d, i) {
        d.classList.toggle('is-active', i === idx);
      });
    }

    snapScroller.addEventListener('scroll', update, { passive: true });
    update();
  }

  /* ── Feature card 3D tilt ────────────────────── */
  function initTilt(root) {
    var cards = root.querySelectorAll('[data-tilt]');
    cards.forEach(function (card) {
      card.addEventListener('mousemove', function (e) {
        var rect = card.getBoundingClientRect();
        var x = (e.clientX - rect.left) / rect.width;
        var y = (e.clientY - rect.top) / rect.height;
        var rx = (0.5 - y) * 15;
        var ry = (x - 0.5) * 15;
        card.style.transform = 'perspective(1000px) rotateX(' + rx + 'deg) rotateY(' + ry + 'deg) scale3d(1.02,1.02,1.02)';
      });
      card.addEventListener('mouseleave', function () {
        card.style.transform = 'perspective(1000px) rotateX(0deg) rotateY(0deg) scale3d(1,1,1)';
      });
    });
  }

  function initScrollReveal(root) {
    var els = root.querySelectorAll('.gsap-reveal');
    if (!els.length || !('IntersectionObserver' in window)) return;

    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });

    els.forEach(function (el) { obs.observe(el); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (ev) {
    if (!ev.target) return;
    var root = ev.target.querySelector('[data-pixelmob-root]');
    var navHost = ev.target.querySelector('[data-pixelmob-nav]');
    if (ev.target.matches && ev.target.matches('[data-pixelmob-nav]')) navHost = ev.target;
    if (root) root.removeAttribute('data-pixelmob-init');
    if (navHost) navHost.removeAttribute('data-pixelmob-nav-init');
    if (root || navHost) init();
  });
})();
